module.exports = __webpack_public_path__ + "static/f2-f4cd85d5e413a69c84e5c61b48f0e729.png";